// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2 10H22V12H21V20H22V22H16V15H8V22H2V20H3V12H2V10Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M10 22V17H14V22H10Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M19 2H5V4H6V8H18V4H19V2ZM13.002 3.99805V6.00195H10.998V3.99805H13.002Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-double-storey-filled')
export default class DoubleStoreyFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'double-storey-filled',
    }
  }
}
